import React, { useState } from 'react';
import { AuthAPI } from '../services/auth';
import { getErrorMessage } from '../services/http';

export default function LoginScreen({ onLogin, notice = '' }) {
  const [mode, setMode] = useState('login');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [registerForm, setRegisterForm] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    role: 'operacional'
  });

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const session = await AuthAPI.login(loginForm);
      onLogin(session);
    } catch (requestError) {
      setError(getErrorMessage(requestError, 'Não foi possível autenticar.'));
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const session = await AuthAPI.register(registerForm);
      onLogin(session);
    } catch (requestError) {
      setError(getErrorMessage(requestError, 'Não foi possível cadastrar o usuário.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-card shadow-lg">
        <div className="eyebrow">Task Hub</div>
        <h1>Central operacional da CEC</h1>
        <p className="text-muted mb-4">
          Entre com sua conta para assumir tarefas, registrar andamento e repassar a demanda para o próximo responsável.
        </p>

        <div className="d-flex gap-2 mb-3">
          <button className={`btn ${mode === 'login' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setMode('login')}>
            Login
          </button>
          <button className={`btn ${mode === 'register' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setMode('register')}>
            Cadastrar
          </button>
        </div>

        {notice && <div className="alert alert-warning">{notice}</div>}
        {error && <div className="alert alert-danger">{error}</div>}

        {mode === 'login' ? (
          <form onSubmit={handleLogin} className="d-grid gap-3">
            <div>
              <label className="form-label">E-mail</label>
                <input
                  className="form-control"
                  type="email"
                  autoComplete="email"
                  value={loginForm.email}
                  onChange={(event) => setLoginForm((current) => ({ ...current, email: event.target.value }))}
                  placeholder="voce@empresa.com"
              />
            </div>

            <div>
              <label className="form-label">Senha</label>
                <input
                  className="form-control"
                  type="password"
                  autoComplete="current-password"
                  value={loginForm.password}
                  onChange={(event) => setLoginForm((current) => ({ ...current, password: event.target.value }))}
                  placeholder="Sua senha"
              />
            </div>

            <button className="btn btn-primary btn-lg" type="submit" disabled={loading}>
              Entrar no painel
            </button>
          </form>
        ) : (
          <form onSubmit={handleRegister} className="d-grid gap-3">
            <div>
              <label className="form-label">Nome</label>
                <input
                  className="form-control"
                  autoComplete="name"
                  value={registerForm.name}
                  onChange={(event) => setRegisterForm((current) => ({ ...current, name: event.target.value }))}
                  placeholder="Nome completo"
              />
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">E-mail</label>
                  <input
                    className="form-control"
                    type="email"
                    autoComplete="email"
                    value={registerForm.email}
                    onChange={(event) => setRegisterForm((current) => ({ ...current, email: event.target.value }))}
                    placeholder="voce@empresa.com"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Telefone para alertas</label>
                  <input
                    className="form-control"
                    autoComplete="tel"
                    value={registerForm.phone}
                    onChange={(event) => setRegisterForm((current) => ({ ...current, phone: event.target.value }))}
                    placeholder="WhatsApp ou telefone"
                />
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Função</label>
                <select
                  className="form-select"
                  value={registerForm.role}
                  onChange={(event) => setRegisterForm((current) => ({ ...current, role: event.target.value }))}
                >
                  <option value="operacional">Operacional</option>
                  <option value="comercial">Comercial</option>
                  <option value="tecnico">Técnico</option>
                  <option value="financeiro">Financeiro</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Senha</label>
                  <input
                    className="form-control"
                    type="password"
                    autoComplete="new-password"
                    value={registerForm.password}
                    onChange={(event) => setRegisterForm((current) => ({ ...current, password: event.target.value }))}
                    placeholder="Crie uma senha"
                />
              </div>
            </div>

            <button className="btn btn-primary btn-lg" type="submit" disabled={loading}>
              Criar conta e entrar
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
